// BLOG
// ===================================================

var blog = {

    settings: {
        featured_posts_slider: $('.featured-posts-slider'),
        mobile_filter_button: $('.js-mobile-filter-button'),
        mobile_filter_close_button: $('.sidebar-filters .js-close-icon'),
    },

    init: function() {
        // Mobile Filter Menu
        if (this.settings.mobile_filter_button.length) {
            this.mobileFilterMenu();
        }
    },

    // Mobile Filter Menu
    mobileFilterMenu: function() {

        // Toggle menu open/close (Filter Button)
        blog.settings.mobile_filter_button.on('click', toggleMenu);
        // Toggle menu open/close (Close Button)
        blog.settings.mobile_filter_close_button.on('click', toggleMenu);
        // Toggle menu open/close (Results Button)
        $('.mobile-results-total').on('click', toggleMenu);

        var filter_menu = $('.post-filter-wrapper');
        var body = $('body');

        function toggleMenu() {
            if (!filter_menu.hasClass('open')) {
                filter_menu.addClass('open');
                body.addClass('no-scroll');
            } else {
                filter_menu.removeClass('open');
                body.removeClass('no-scroll');
            }
        }

    },

};
blog.init();